import {
  messageSent,
  typingFinished,
  typingStarted,
  userChangeEvent,
  userPermacloseEvent,
  userTriggeredEvent
} from './user'

export const chatEvents = [
  messageSent,
]

export const userEvents = [
  typingStarted,
  typingFinished,
  userChangeEvent,
  userPermacloseEvent,
  userTriggeredEvent,
]

export const presenceEvents = []
